module.exports = __webpack_public_path__ + "static/media/alerts.8150be92.svg";